export type RoleTitle = 'Admin' | 'AgencyUser' | 'BrandUser' |
                        'ProviderUser' | 'MasterAdmin' | 'ProviderDirector' |
                        'ProviderUser' | 'Office Administrator' | 'Office Director' |
                        'Agent' | 'Personal Assistant'

export const adminRoles = ['Admin', 'Support', 'Account Manager', 'Sales Executive']

export const masterAdminRoles = ['Admin']

export const agencyAdminRoles = ['Office Administrator', 'Office Director']

export const agentRoles = ['Agent', 'Personal Assistant']

export const agencyRoles = agencyAdminRoles.concat(agentRoles)

export const brandRoles = ['Brand Administrator']

export const providerDirectorRoles = ['Provider Director']

export const providerRoles = ['Provider Director', 'Provider Employee', 'Provider Contractor']

export const supportRoles = agencyRoles.concat(brandRoles).concat(providerRoles).concat('Support')
